import React from 'react';
import PropTypes from 'prop-types';
import './AppLinks.scss';


const AppLinksMessage = ({ playStoreLink, appStoreLink, resortMessage }) => (
  <div className="applink-container">
    <div className="message-container">
      <div>
        <div className="message-text">{resortMessage}</div>
        <div className="message-button">
          <a
            className="btn positive-button"
            href={appStoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            App Store
          </a>
          <a
            className="btn positive-button"
            href={playStoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Play Store
          </a>
        </div>
      </div>
    </div>
  </div>

);

AppLinksMessage.propTypes = {
  playStoreLink: PropTypes.string,
  appStoreLink: PropTypes.string,
  resortMessage: PropTypes.string,
};

export default AppLinksMessage;
